import RoutesEnum from 'enums/routes.enum'
import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import LoadSessionMiddleware from 'middlewares/LoadSessionMiddleware'
import RequireProfileCompleteMiddleware from 'middlewares/RequireProfileCompleteMiddleware'
import ForbidSubdomainMiddleware from 'middlewares/ForbidSubdomainMiddleware'

export default [
    {
        path: '/offer/create',
        name: RoutesEnum.OFFER.CREATE,
        view: 'offer/CreateOffer',
        middlewares: [RequireUserMiddleware, RequireProfileCompleteMiddleware],
        meta: {
            layout: 'main',
            title: 'Kreiranje Ponude | Bookeraj',
            description:
                'Kreirajte svoju ponudu na našoj platformi. Dodajte detalje, cene i slike kako biste privukli potencijalne kupce.',
        },
    },
    {
        path: '/offer/:id/configure/:type',
        name: RoutesEnum.OFFER.CONFIGURE,
        view: 'offer/ConfigureOffer',
        middlewares: [RequireUserMiddleware],
        meta: {
            layout: 'main',
            title: 'Konfigurisanje Ponude | Bookeraj',
            description:
                'Konfigurišite detalje svoje ponude na našoj platformi. Prilagodite cene, opcije i postavke kako biste privukli ciljnu publiku.',
        },
    },
    {
        path: '/offer/find',
        name: RoutesEnum.OFFER.FIND,
        view: 'offer/FindOffers',
        middlewares: [LoadSessionMiddleware],
        meta: {
            layout: 'main',
            title: 'Pronađi Ponude | Bookeraj',
            description:
                'Pretražite naše ponude i pronađite najbolje opcije za svoje potrebe. Pregledajte različite proizvode, usluge i promocije dostupne na našoj platformi.',
        },
    },
    {
        path: '/offer/:id/single/:offerType',
        name: RoutesEnum.OFFER.SINGLE,
        view: 'offer/SingleOffer',
        middlewares: [LoadSessionMiddleware],
        meta: {
            layout: 'main',
            title: 'Pojedinačna Ponuda | Bookeraj',
            description:
                'Pregledajte detalje o ovoj pojedinačnoj ponudi na našoj platformi. Saznajte više o proizvodu ili usluzi, ceni i dostupnim opcijama.',
        },
    },
    {
        path: '/offer/favorites',
        name: RoutesEnum.OFFER.FAVORITES,
        view: 'offer/FavoritesOffers',
        middlewares: [LoadSessionMiddleware, ForbidSubdomainMiddleware],
        meta: {
            layout: 'main',
            title: 'Omiljene Ponude | Bookeraj',
            description:
                'Pretražite vaše omiljene ponude i pronađite najbolje opcije za svoje potrebe. Pregledajte različite proizvode, usluge i promocije dostupne na našoj platformi. ',
        },
    },
]
